import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { setHeaderTitle, setSubHeaderTitle } from "stores/slices/layout";

import CustomerTable from "components/customer/customerTable";

const OperatorCustomerPage = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const [isOpenCustomerForm, setIsOpenCustomerForm] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const location = useLocation();
  const [isAdd, setIsAdd] = useState(false);
  useEffect(() => {
    dispatch(setHeaderTitle(["customer", "allCustomers"]));
    if (location.state && location.state.name) {
      dispatch(setHeaderTitle(["customer", "broadcastList"]));
      dispatch(setSubHeaderTitle(location.state.name));
      location.state = {};
    }
  }, []);

  return (
    <>
      <CustomerTable
        params={params}
        isAdd={isAdd}
        setIsAdd={setIsAdd}
        isOpenCustomerForm={isOpenCustomerForm}
        setIsOpenCustomerForm={setIsOpenCustomerForm}
        isRefresh={isRefresh}
        setIsRefresh={setIsRefresh}
      />
    </>
  );
};

export default OperatorCustomerPage;
